export { default } from './fetchCloudSearch'